import "./OrganizationLookup.js";
import "./addOrgFacilityForm.js";
import "./details.js";
import "./brokerorgdetails.js";
import "./carrierdetails.js";

import moment from "moment";
import _ from "underscore";
import merge from "deepmerge";


export {merge};



export function isPresent(val){
    return !_.isUndefined(val) && !_.isNull(val) && val !== "";
  }
  
  export function isBlank(val){
    return _.isUndefined(val) || _.isNull(val) || val === "";
  }


// WEBPACK FOOTER //
// ./src/pages/addressBook/index.js